export const data = [{
    title: 'ИФТИТОҲИ БИНОИ ХОБГОҲИ ДОНИШҶӮЁНИ ДОНИШГОҲИ ДАВЛАТИИ ТИББИИ ХАТЛОН',
    date: '15-06-2022',
    img: 'https://maorif.tj/storage/posts/June2022/iVlL7LPWrIQAxrvtDLGr.jpg'
},
{
    title: 'ВОХӮРИИ САИДЗОДА РАҲИМ ҲАМРО БО МУҲАММАД РАШИД МААНИН',
    date: '15-06-20221',
    img: 'https://www.maorif.tj/storage/posts/June2022/A4CvbKmIiJB6VuJRvxL9.jpg'
},
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
},
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}

    ,
{
    title: 'ВОХӮРИИ САИДЗОДА РАҲИМ ҲАМРО БО МУҲАММАД РАШИД МААНИН',
    date: '15-06-20221',
    img: 'https://www.maorif.tj/storage/posts/June2022/A4CvbKmIiJB6VuJRvxL9.jpg'
},
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
},
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
    ,
{
    title: 'БОЗДИДИ ВАЗИРИ МАОРИФ ВА ИЛМ АЗ МУАССИСАИ ТАҲСИЛОТИ ТОМАКТАБИИ ХУСУСИИ “СУМАН”',
    date: '15-06-20232',
    img: 'https://www.maorif.tj/storage/posts/June2022/1DA6JxYP72btmorKRjWs.jpg'
},
{
    title: 'ВОХӮРИИ ҶАМШЕД ҶӮРАЗОДА БО МУҲАММАД ФАҶРУЛ РАҲМОН',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/J50IIUeCcG1QtPW7y8a1.jpg'
},
{
    title: 'ВОХӮРИИ НАМОЯНДАГОНИ ВАЗОРАТИ МАОРИФ ВА ИЛМ БО ФОНДИ АВРУПОИИ МАОРИФ',
    date: '15-06-2022',
    img: 'https://www.maorif.tj/storage/posts/June2022/ZMlGc3NZW54DLrUOfcam.jpg'
}
]


